import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "text-overview ps-2" };
const _hoisted_2 = { class: "d-flex flex-column mt-38px" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-5" };
const _hoisted_6 = { class: "py-2" };
const _hoisted_7 = { class: "premialita-title" };
const _hoisted_8 = { class: "ps-1" };
const _hoisted_9 = { class: "d-flex flex-column mb-3 mt-1" };
const _hoisted_10 = { class: "row align-items-center" };
const _hoisted_11 = {
    class: "col-sm-1 flex-grow-1",
    style: { "cursor": "default" }
};
const _hoisted_12 = { class: "row align-items-center" };
const _hoisted_13 = { class: "col-sm-1" };
const _hoisted_14 = ["onUpdate:modelValue", "onChange"];
const _hoisted_15 = { class: "row align-items-center" };
const _hoisted_16 = { class: "col-sm-1" };
const _hoisted_17 = ["onUpdate:modelValue", "onInput"];
const _hoisted_18 = {
    class: "col-5 pb-3",
    style: { "max-width": "350px" }
};
const _hoisted_19 = {
    key: 0,
    class: "premialita-text"
};
const _hoisted_20 = { class: "d-flex flex-row align-items-center" };
const _hoisted_21 = ["src", "alt"];
const _hoisted_22 = {
    class: "premialita-text ml-12px text-truncate",
    style: { "max-width": "170px" }
};
const _hoisted_23 = ["checked", "onChange"];
const _hoisted_24 = {
    class: "col",
    style: { "padding-right": "0" }
};
const _hoisted_25 = { class: "d-flex flex-row premialita-title pt-2 pb-1 justify-content-end" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["src"];
import { computed, ref } from "vue";
import axios from 'axios';
import Vue3EasyDataTable from "vue3-easy-data-table";
import ButtonComponent from '../components/Button.vue';
import SelectModal from '../components/SelectModal.vue';
import { useToast } from 'vue-toast-notification';
import { validateNumericInput } from '../lib/utils';
import { container as WidgetContainerModal, openModal } from "jenesius-vue-modal";
import 'vue-toast-notification/dist/theme-sugar.css';
import "vue3-easy-data-table/dist/style.css";
import TrashIcon from '../assets/icons/trash.png';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TypeAMuseumPremialita',
    props: {
        baseUrl: { type: String },
        token: { type: String },
        activities: { type: Array },
        visitTypes: { type: Array },
        campaignId: { type: String },
        museumId: { type: String }
    },
    emits: ["onUpdate"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const isLoading = ref(false);
        const getError = ref(null);
        const pages = ref(0);
        const allVisitTypes = ref([...props.visitTypes]);
        const items = ref([...props.activities]);
        let debounceTimer = null; // si può prevedere il debounce per ogni riga della tabella ma non dovrebbe essere necessario
        const serverOptions = ref({
            page: 1,
            rowsPerPage: 5
        });
        const $toast = useToast();
        const usedVisitTypesCount = computed(() => {
            const usedVisitTypes = props.activities
                .filter(el => el.activity.campaign.uuid === props.campaignId)
                .map(el => el.visitType);
            return new Set(usedVisitTypes).size;
        });
        const visitTypesSummary = computed(() => {
            const tipologie = usedVisitTypesCount.value === 1 ? "tipologia" : "tipologie";
            return `${usedVisitTypesCount.value} ${tipologie} di visita su ${allVisitTypes.value.length} presenti`;
        });
        const toggleOffer = (item, offer) => {
            const offers = item.offers;
            const index = offers.findIndex(o => o.uuid === offer.uuid);
            if (index === -1)
                offers.push(offer);
            else
                offers.splice(index, 1);
            handleUpdate(item);
        };
        const handleAddActivityModal = async () => {
            const modalProps = {
                modalTitle: 'Aggiungi attività',
                selectOptions: allVisitTypes
            };
            const modal = await openModal(SelectModal, modalProps);
            modal.on('return', (selectedValue) => {
                handleCreate(selectedValue);
            });
        };
        const handleDelete = async (activityId) => {
            await activityAction('delete', `/${activityId}`, null, 'Attività eliminata con successo');
        };
        const handleCreate = async (visitTypeSelected) => {
            const data = {
                status: 'DRAFT',
                campaignId: props.campaignId,
                points: visitTypeSelected.fullPrice,
                visitType: visitTypeSelected.name,
                value: visitTypeSelected.fullPrice,
                offers: []
            };
            await activityAction('post', '', data, 'Attività creata con successo');
        };
        const handleUpdate = async (row) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(async () => {
                console.log(row.activity.status.id);
                const data = {
                    status: row.activity.status.id === 1 ? 'PUBLISHED' : 'DRAFT',
                    campaignId: props.campaignId,
                    points: row.activity.points,
                    visitType: row.visitType,
                    value: row.value,
                    offers: row.offers.map(offer => offer.uuid)
                };
                await activityAction('put', `/${row.activity.uuid}`, data, 'Attività aggiornata con successo');
            }, 500);
        };
        const activityAction = async (method, path, data, msg) => {
            isLoading.value = true;
            try {
                await axios({
                    method,
                    url: `${props.baseUrl}/v1/private/museums/${props.museumId}/activity${path}`,
                    data,
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                $toast.success(msg, { position: 'top-right' });
                emit('onUpdate');
            }
            catch (error) {
                console.error(error);
                getError.value = error;
                $toast.error(error.response.data.title, { position: 'top-right' });
            }
            finally {
                isLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("p", _hoisted_1, _toDisplayString(visitTypesSummary.value), 1),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(ButtonComponent, {
                        class: "bg-primary-custom align-self-end me-3 mb-2",
                        isDisable: isLoading.value,
                        text: "Aggiungi Tipologia di Visita",
                        type: "primary",
                        onHandleClick: handleAddActivityModal
                    }, null, 8, ["isDisable"]),
                    _createVNode(_unref(Vue3EasyDataTable), {
                        headers: [{ text: '', value: 'fake' }],
                        "server-options": serverOptions.value,
                        "onUpdate:serverOptions": _cache[0] || (_cache[0] = ($event) => ((serverOptions).value = $event)),
                        "server-items-length": pages.value,
                        items: items.value.filter(el => el.activity.campaign.uuid === props.campaignId),
                        loading: isLoading.value,
                        "no-hover": true,
                        alternating: "",
                        "buttons-pagination": ""
                    }, {
                        item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _cache[1] || (_cache[1] = _createTextVNode(" Tipo di Visita: ", -1)),
                                                _createElementVNode("b", _hoisted_8, _toDisplayString(item.visitType), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-sm-3 premialita-text premialita-attivita" }, " Valore Intero: ", -1)),
                                                _createElementVNode("div", _hoisted_11, _toDisplayString(`€ ${item.value}`), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-sm-3 premialita-text premialita-attivita" }, " Attività premiante: ", -1)),
                                                _createElementVNode("div", _hoisted_13, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        style: { "cursor": "pointer" },
                                                        "true-value": 1,
                                                        "false-value": 2,
                                                        "onUpdate:modelValue": ($event) => ((item.activity.status.id) = $event),
                                                        onChange: ($event) => (handleUpdate(item))
                                                    }, null, 40, _hoisted_14), [
                                                        [_vModelCheckbox, item.activity.status.id]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-sm-3 premialita-text premialita-attivita" }, " Assegna punti: ", -1)),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "premialita-input",
                                                        "onUpdate:modelValue": ($event) => ((item.activity.points) = $event),
                                                        style: _normalizeStyle({ width: `${String(item.activity.points).length + 4 || 4}ch`, background: 'transparent !important', textAlign: 'left' }),
                                                        onInput: ($event) => (item.activity.points = _unref(validateNumericInput)(item.activity.points), handleUpdate(item))
                                                    }, null, 44, _hoisted_17), [
                                                        [_vModelText, item.activity.points]
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "premialita-title pt-2 pb-3" }, " Elenco Adesioni ", -1)),
                                        (item.activity.campaign.offers?.filter(o => o.status?.name === 'PUBLISHED').length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Nessuna offerta disponibile pubblicata "))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.activity.campaign.offers.filter(o => o.status?.name === 'PUBLISHED'), (offer) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: offer.uuid,
                                                    class: "d-flex flex-row align-items-center gap-1 justify-content-between"
                                                }, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("img", {
                                                            src: offer.images[0]?.thumb,
                                                            alt: offer.images[0]?.alt,
                                                            class: "offers-list-img my-1"
                                                        }, null, 8, _hoisted_21),
                                                        _createElementVNode("div", _hoisted_22, _toDisplayString(offer.name), 1)
                                                    ]),
                                                    _createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        style: { "cursor": "pointer" },
                                                        checked: item.offers?.some(activityOffer => activityOffer.uuid === offer.uuid),
                                                        onChange: ($event) => (toggleOffer(item, offer))
                                                    }, null, 40, _hoisted_23)
                                                ]));
                                            }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("a", {
                                                onClick: ($event) => (handleDelete(item.activity.uuid))
                                            }, [
                                                _createElementVNode("img", {
                                                    src: _unref(TrashIcon),
                                                    alt: "",
                                                    class: "mt-1",
                                                    style: { "width": "17px", "height": "17px", "cursor": "pointer" }
                                                }, null, 8, _hoisted_27)
                                            ], 8, _hoisted_26)
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["server-options", "server-items-length", "items", "loading"])
                ]),
                _createVNode(_unref(WidgetContainerModal))
            ], 64));
        };
    }
});
